document.documentElement.classList.remove('no-js');

if (window.Shopify && window.Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}

let revealObserver;

const findWithin = (root, selector) => {
  const matches = [];
  if (root instanceof Element && root.matches(selector)) matches.push(root);
  return matches.concat(Array.from(root.querySelectorAll(selector)));
};

const revealItems = (root = document) => {
  const items = findWithin(root, '.reveal:not(.is-visible)');
  const isThemeEditor = document.documentElement.classList.contains('shopify-design-mode') || Boolean(window.Shopify && window.Shopify.designMode);

  if (isThemeEditor || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  if (!revealObserver) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
  }

  items.forEach((item) => revealObserver.observe(item));
};

const initMobileNavigation = (root = document) => {
  findWithin(root, '[data-mobile-toggle]').forEach((button) => {
    if (button.dataset.mobileToggleBound === 'true') return;
    button.dataset.mobileToggleBound = 'true';

    button.addEventListener('click', () => {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  });
};

const showProductMedia = (section, mediaId) => {
  if (!mediaId) return;
  section.querySelectorAll('[data-product-media]').forEach((media) => {
    const active = media.dataset.productMedia === String(mediaId);
    media.hidden = !active;
    media.classList.toggle('is-active', active);
  });
  section.querySelectorAll('[data-media-target]').forEach((button) => {
    const active = button.dataset.mediaTarget === String(mediaId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
};

const initProductSections = (root = document) => {
  findWithin(root, '[data-product-section]').forEach((section) => {
    section.querySelectorAll('[data-media-target]').forEach((button) => {
      if (button.dataset.mediaBound === 'true') return;
      button.dataset.mediaBound = 'true';
      button.addEventListener('click', () => showProductMedia(section, button.dataset.mediaTarget));
    });

    const select = section.querySelector('[data-variant-select]');
    if (!select || select.dataset.variantBound === 'true') return;
    select.dataset.variantBound = 'true';
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const sku = section.querySelector('[data-product-sku]');
      const stock = section.querySelector('[data-product-stock]');
      const button = section.querySelector('[data-add-to-cart]');

      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.compareVisible !== 'true';
      }
      if (sku) sku.textContent = option.dataset.sku || '–';
      if (stock) {
        stock.textContent = available ? (stock.dataset.inStockLabel || 'Auf Lager') : (button?.dataset.soldLabel || 'Ausverkauft');
        stock.classList.toggle('is-sold-out', !available);
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      if (option.dataset.mediaId) showProductMedia(section, option.dataset.mediaId);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
};

let scrollArtTimer;
const revealScrollArt = () => {
  const scrollArtItems = document.querySelectorAll('.scroll-halloween-background');
  if (!scrollArtItems.length) return;
  scrollArtItems.forEach((item) => item.classList.add('is-scrolling'));
  window.clearTimeout(scrollArtTimer);
  scrollArtTimer = window.setTimeout(() => {
    document.querySelectorAll('.scroll-halloween-background').forEach((item) => item.classList.remove('is-scrolling'));
  }, 520);
};

const initThemeContent = (root = document) => {
  initMobileNavigation(root);
  initProductSections(root);
  revealItems(root);
};

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations?.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML;
            initThemeContent(this);
          }
        })
        .catch(() => { this.dataset.loaded = 'false'; });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initThemeContent();
  window.addEventListener('scroll', revealScrollArt, { passive: true });
});

document.addEventListener('shopify:section:load', (event) => initThemeContent(event.target));
document.addEventListener('shopify:section:select', (event) => revealItems(event.target));
document.addEventListener('shopify:section:reorder', (event) => revealItems(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest('.reveal');
  if (item) item.classList.add('is-visible');
});
